import { ModelEnum } from './Model.model';

enum Product {
  TELEOPHTH = 'teleophth',
  TELEOPHTH_STANDALONE = 'teleophth-standalone',
}

export const getModels = (product: Product): ModelEnum[] => {
  if ([Product.TELEOPHTH, Product.TELEOPHTH_STANDALONE].includes(product)) {
    return [ModelEnum.GENERAL_QUALITY];
  }

  throw new Error(`Unknown product ${product}`);
};

const ProductFullName = (product: Product): string => {
  switch (product) {
    case Product.TELEOPHTH: {
      return 'Teleophthalmology';
    }
    case Product.TELEOPHTH_STANDALONE: {
      return 'Teleophthalmology Standalone';
    }
    default: {
      return `Unknown: ${product}`;
    }
  }
};

export { Product, ProductFullName };
